module.exports = __webpack_public_path__ + "static/androidBannerCTO-df6d69f8bde418b403255f0bc253f090.jpeg";